import GraphLink from './graphLink';
import GraphNode from './graphNode';
import { mark, arrayReplace } from './index';
class Graph {
    nodeList;
    linkList;
    insertNodeList;
    shrinkNodeList;
    appendNodeList;
    insertLineList;
    shrinkLineList;
    origin;
    mouseOnLink;
    mouseonNode;
    maskBoundingClientRect;
    nodeMap;
    readonly;
    hiddenAppend;
    constructor(options) {
        const { relationMark, startMark, endMark, linkList = [], nodeList = [], origin, readonly, hiddenAppend, } = options;
        Object.assign(mark, {
            relationMark,
            startMark,
            endMark,
        });
        this.nodeList = [];
        this.linkList = [];
        this.origin = origin;
        this.mouseOnLink = null;
        this.mouseonNode = null;
        this.maskBoundingClientRect = {};
        this.readonly = readonly;
        this.hiddenAppend = hiddenAppend;
        this.initNode(nodeList);
        this.initLink(linkList);
        this.initButtonAndLine(linkList);
    }
    // 源数组map映射节点
    originPointMap(nodeList) {
        const map = {};
        nodeList.forEach(point => {
            map[point[mark.relationMark]] = point;
        });
        return map;
    }
    // 节点映射 创建连线时需要用到
    pointMap() {
        const map = {};
        this.nodeList.forEach(point => {
            map[point[mark.relationMark]] = point;
        });
        return map;
    }
    initNode(nodeList) {
        arrayReplace(this.nodeList, nodeList.map(node => this.createNode(node)));
        this.nodeMap = this.originPointMap(nodeList);
    }
    initLink(linkList) {
        arrayReplace(this.linkList, linkList.map(link => this.createLink(link)));
    }
    createNode(options) {
        return new GraphNode(options, this);
    }
    createLink(options) {
        return new GraphLink(options, this);
    }
    clearButtonAndLine() {
        this.insertNodeList = [];
        this.shrinkNodeList = [];
        this.appendNodeList = [];
        this.insertLineList = [];
        this.shrinkLineList = [];
    }
    // 初始化按钮和线段
    initButtonAndLine(linkList) {
        this.clearButtonAndLine();
        this.nodeList.forEach(node => {
            // 初始化【+】
            if (node.meta.extParam.isOpen &&
                node.meta.extParam.canInsert &&
                !node.meta.extParam.isDragElement &&
                !this.readonly) {
                this.insertNodeList.push(node);
            }
            //【展开收起】
            const hasNextNodeAndNotEmpty = linkList.some(link => link.startId === node.id && link?.meta?.activeId === -1 && !link.meta?.isDragElement);
            if (hasNextNodeAndNotEmpty) {
                this.shrinkNodeList.push(node);
            }
            // 初始化【添】
            if (!node.meta?.extParam?.isDragElement &&
                !['start_node', 'empty'].includes(node.meta?.configKey) &&
                !this.readonly &&
                !this.hiddenAppend) {
                this.appendNodeList.push(node);
            }
            // 【+】的连线
            if (node.meta.extParam.isOpen &&
                node.meta.extParam.canInsert &&
                !this.linkList.some(link => link.startId === node.id) &&
                !node.meta.extParam.isDragElement) {
                this.insertLineList.push(node);
            }
            // 【展开收起】的连线
            if (!node.meta.extParam.isOpen && !node.meta.extParam.isDragElement) {
                this.shrinkLineList.push(node);
            }
        });
    }
}
export default Graph;
